// About.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TechstackSlider from "./Techstack";
import Aboutcard from "./AboutCard";
import Toolstack from "./Toolstack";
import Languages from "./Languages";
import Education from "./Education"; // Nouveau composant ajouté
import { useTranslation } from "react-i18next"; // Hook de traduction
import SmartUnderlineTitle from "../SmartUnderline/SmartUnderline";
import "./About.css";

function About() {
  const { t } = useTranslation(); // Hook pour récupérer les traductions

// Dans About.js, ajoute un petit useEffect pour le déclenchement
const [isReady, setIsReady] = React.useState(false);

React.useEffect(() => {
  const timer = setTimeout(() => setIsReady(true), 100); // Petit délai pour le confort visuel
  return () => clearTimeout(timer);
}, []);

  return (
    <Container fluid className="about-section">
      <Container>
        {/* Section Présentation */}
        <Row style={{ justifyContent: "center" }}>
          <Col
            xs={11}
            sm={11}
            md={10}
            lg={7}
            style={{ justifyContent: "center", paddingBottom: "50px" }}
          >
<SmartUnderlineTitle isReady={isReady} className="about-heading main-title">
  <span className="purple">{t("about_title")}</span>
</SmartUnderlineTitle>

            <div style={{ marginTop: "15px" }}>
              <Aboutcard />
            </div>
          </Col>
        </Row>

        {/* Section Éducation */}
        <h1 className="about-heading subtle-title">
          <span className="black">{t("education_title")}</span>
        </h1>
        <Education />

        {/* Section Compétences Techniques */}
        <h1 className="about-heading subtle-title">
          <span className="black">{t("technical_skills")}</span>
        </h1>
        <TechstackSlider />

        {/* Section Outils */}
        <h1 className="about-heading subtle-title">
          <span className="black">{t("work_tools")}</span>
        </h1>
        <Toolstack />

        {/* Section Langues */}
        <h1 className="about-heading subtle-title">
          <span className="black">{t("languages_title")}</span>
        </h1>
        <Languages />
      </Container>
    </Container>
  );
}

export default About;
